"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeesAndMevPoolSubPackage = void 0;
const feesAndMevPool_1 = require("../logic/feesAndMevPool");
class FeesAndMevPoolSubPackage {
    constructor(signer, feesAndMevPoolAddress) {
        this.etherSigner = signer,
            this.feesAndMevPoolAddress = feesAndMevPoolAddress;
    }
    totalShares() {
        return (0, feesAndMevPool_1._totalShares)(this.etherSigner, this.feesAndMevPoolAddress);
    }
    updateAccumulatedETHPerLP() {
        return (0, feesAndMevPool_1._updateAccumulatedETHPerLP)(this.etherSigner, this.feesAndMevPoolAddress);
    }
    batchDepositETHForStaking(blsPublicKeys, amounts, ethValue) {
        return (0, feesAndMevPool_1._batchDepositETHForStaking)(this.etherSigner, this.feesAndMevPoolAddress, blsPublicKeys, amounts, ethValue);
    }
    depositETHForStaking(blsPublicKey, amount, ethValue) {
        return (0, feesAndMevPool_1._depositETHForStaking)(this.etherSigner, this.feesAndMevPoolAddress, blsPublicKey, amount, ethValue);
    }
    burnLPTokensForETHByBLS(blsPublicKeys, amounts) {
        return (0, feesAndMevPool_1._burnLPTokensForETHByBLS)(this.etherSigner, this.feesAndMevPoolAddress, blsPublicKeys, amounts);
    }
    burnLPTokensForETH(lpTokens, amounts) {
        return (0, feesAndMevPool_1._burnLPTokensForETH)(this.etherSigner, this.feesAndMevPoolAddress, lpTokens, amounts);
    }
    burnLPTokenForETH(lpToken, amount) {
        return (0, feesAndMevPool_1._burnLPTokenForETH)(this.etherSigner, this.feesAndMevPoolAddress, lpToken, amount);
    }
    claimRewards(recipient, blsPublicKeys) {
        return (0, feesAndMevPool_1._claimRewards)(this.etherSigner, this.feesAndMevPoolAddress, recipient, blsPublicKeys);
    }
    batchPreviewAccumulatedETH(userAddress, lpTokens) {
        return (0, feesAndMevPool_1._batchPreviewAccumulatedETH)(this.etherSigner, this.feesAndMevPoolAddress, userAddress, lpTokens);
    }
    claimFundsFromSyndicateForDistribution(blsPublicKeys) {
        return (0, feesAndMevPool_1._claimFundsFromSyndicateForDistribution)(this.etherSigner, this.feesAndMevPoolAddress, blsPublicKeys);
    }
    batchClaimETHFromRageQuit(lpTokens, amounts) {
        return (0, feesAndMevPool_1._batchClaimETHFromRageQuit)(this.etherSigner, this.feesAndMevPoolAddress, lpTokens, amounts);
    }
    claimETHFromRageQuit(lpToken, amount) {
        return (0, feesAndMevPool_1._claimETHFromRageQuit)(this.etherSigner, this.feesAndMevPoolAddress, lpToken, amount);
    }
}
exports.FeesAndMevPoolSubPackage = FeesAndMevPoolSubPackage;
